export default function selectImg({main, on, elm, state}) {
    main(_ => {
        on('change', 'select', changeImage)
    });

    const changeImage = function() {
        const model = state.get();
        const option = this.querySelector('option:checked');
        const image = option.dataset.image ?? model.defaultImage;
        if (image) {
            state.set(s => s.image = image);
        }
    };
};

export const model = {
    image: null
};